import { Decoration_Type } from 'ricos-schema';
import type { TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

import { ITALIC_BUTTON_DATA_HOOK } from './data-hooks';
import { italic } from './extension';
import ItalicIcon from './ItalicIcon';

export const pluginItalic: TiptapEditorPlugin = {
  type: Decoration_Type.ITALIC,
  config: {},
  tiptapExtensions: [italic],
  shortcuts: [
    createShortcut({
      name: Decoration_Type.ITALIC,
      description: 'ShortcutsSheet_Formatting_Italic',
      keys: { macOs: 'Meta+I', windows: 'Ctrl+I' },
      command({ editorCommands }) {
        editorCommands.toggleInlineStyle('italic');
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  textButtons: [
    {
      id: Decoration_Type.ITALIC,
      type: 'toggle',
      presentation: {
        dataHook: ITALIC_BUTTON_DATA_HOOK,
        tooltip: 'ItalicButton_Tooltip',
        icon: ItalicIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_ITALIC,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      command:
        ({ editorCommands }) =>
        () => {
          editorCommands.toggleInlineStyle('italic');
          return true;
        },
    },
  ],
};
